var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer sticky footer-type-1"},[_c('div',{staticClass:"footer-inner"},[_c('div',{staticClass:"footer-text"},[_vm._v(" © AI Tool Jar ")]),_c('div',{staticClass:"go-up"},[_c('a',{attrs:{"href":"#","rel":"go-top"}},[_c('i',{staticClass:"fa-angle-up"})])])])])
}]

export { render, staticRenderFns }